<template>
    <div    class="">
        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="flex flex-col">
            <div class="-my-2 overflow-y-visible overflow-x-auto">
                <div class="py-2 align-middle inline-block min-w-full">
                    <!-- Above table area -->
                    <div    class="pb-2 flex ">
                        <slot   name="above_table">
                            <div    class="w-full flex flex-col sm:flex-row justify-between">
                                <!-- Top left of table -->
                                <div    class="flex-1 w-full sm:max-w-80">
                                    <slot name="above_table_left">

                                    </slot>
                                </div>

                                <!-- Top-Center of Table -->
                                <div    class="flex-1">
                                    <slot   name="above_table_center">

                                    </slot>
                                </div>

                                <!-- Top-Right of Table -->
                                <div    class="flex justify-end items-center shrink-0">
                                    <div    v-if="exportable"
                                            class="shrink-0 min-w-8 flex justify-end items-center"
                                    >
                                        <div    class="w-1/3 min-w-min px-2">
                                            <!-- Specify :fetch in order to load via Ajax -->
                                            <download-excel     v-if="exportFetchRoute !== null && exportFetchRoute !== ''"
                                                :fetch="exportData"
                                                :fields="exportCsvFields"
                                                type="csv">
                                                <green-button>
                                                    Export
                                                </green-button>
                                            </download-excel>

                                            <download-excel     v-else
                                                :data="data"
                                                :fields="exportCsvFields"
                                                type="csv">
                                                <green-button>
                                                    <div    class="flex items-center">
                                                        <span   class="pr-2"
                                                                :class="iconDownload"></span>
                                                        <span>Export</span>
                                                    </div>
                                                </green-button>
                                            </download-excel>
                                        </div>
                                    </div>

                                    <slot   name="above_table_right">

                                    </slot>
                                </div>
                            </div>
                        </slot>
                    </div>
                    
                    <!-- Table -->
                    <div    :class="tableColors[tableColorSet]['rowPrimaryBackgroundColor']"
                            class="bg-white overflow-y-visible overflow-x-auto rounded-md border border-gray-200">
                        <ul class="m-0">
                            <!-- Headers -->
                            <li>
                                <div :class="[columnClasses, tableColors[tableColorSet]['headerBackgroundColor']]"
                                     class="text-gray-500 font-semibold grid focus:outline-none border-b border-gray-200">
                                    <slot   name="table_header"
                                            :headers="headers">
                                        <div    v-for="header in headers"
                                                :class="[header.show === 'sm' || !('show' in header) ? `flex` : `hidden ${header.show}:flex`]">
                                            <div    v-if="sortable && header.sortBy !== ''"
                                                    @click="updateSort(header.sortBy)"
                                                    class="cursor-pointer col-span-1 flex items-center px-4 py-4 sm:px-6 ">
                                                <span class="pr-2">{{ header.name }}</span>
                                                <span v-show="sortBy === header.sortBy" :class="sortDesc ? iconSortDesc : iconSortAsc"></span>
                                            </div>
                                            <div    v-else
                                                    class="px-4 py-4 sm:px-6 ">
                                                <span class="pr-2">{{ header.name }}</span>
                                            </div>
                                        </div>
                                    </slot>
                                </div>
                            </li>

                            <!-- Rows -->
                            <slot   name="table_body"
                                    :data="data">
                                <li     v-if="data.length === 0">
                                    <slot   name="no-data">

                                        <div class="flex flex-col items-center justify-center py-6">
                                            <svg class="text-gray-500" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"/><path d="M4 13h3l3 3h4l3 -3h3"/></svg>
                                            <span class="text-base font-medium text-gray-700">{{ noDataMessage }}</span>
                                        </div>

                                    </slot>
                                </li>
                                <li     v-else-if="data.length > 0"
                                        v-for="(row, rowIndex) in data"
                                        :class="getRowColor(rowIndex)"
                                        class="overflow-y-visible">


                                    <!-- Group Row -->
                                    <div    v-if="Object.keys(row).indexOf('groupName') !== -1"
                                            :class="tableColors[tableColorSet]['groupRowBackgroundColor']"
                                            class="flex justify-start items-center">
                                        <slot   name="group-row"
                                                :row="row"
                                                :rowIndex="rowIndex"></slot>
                                    </div>

                                    <!-- Normal Row -->
                                    <context-menu
                                        v-else-if="contextMenuEnabled"
                                        :resource="contextMenuResource"
                                        :resource-id="row[contextMenuResourceIdKey]"
                                        wrapper-class="table-row-context-wrapper">
                                        <div
                                                :class="tableColors[tableColorSet]['hoverBackgroundColor']"
                                                class="flex flex-row hover:bg-gray-100 overflow-y-visible">
                                            <div
                                                class="grow grid overflow-y-visible"
                                                @mousedown="startRowPress"
                                                @mouseup="endRowPress"
                                                :class="columnClasses + [rowSelectable ? ' cursor-pointer ' : ''] + [rowIndex === $data._selectedRow && this.allowHighlightedRows ? ' bg-blue-300 ' : '']">
                                                <slot   name="table-row"
                                                        :row="row"
                                                        :rowIndex="rowIndex">
                                                <!-- Column 1 -->
                                                <div    v-if="headers.length >= 1"
                                                        @click="selectRow(rowIndex, 0)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[0].show === 'sm' || !('show' in headers[0]) ? `flex` : `hidden ${headers[0].show}:flex`]">
                                                    <slot   name="col-1"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[0].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 2 -->
                                                <div    v-if="headers.length >= 2"
                                                        @click="selectRow(rowIndex, 1)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[1].show === 'sm' || !('show' in headers[1]) ? `flex` : `hidden ${headers[1].show}:flex`]">
                                                    <slot   name="col-2"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[1].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 3 -->
                                                <div    v-if="headers.length >= 3"
                                                        @click="selectRow(rowIndex, 2)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[2].show === 'sm' || !('show' in headers[2]) ? `flex` : `hidden ${headers[2].show}:flex`]">
                                                    <slot   name="col-3"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[2].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 4 -->
                                                <div    v-if="headers.length >= 4"
                                                        @click="selectRow(rowIndex, 3)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[3].show === 'sm' || !('show' in headers[3]) ? `flex` : `hidden ${headers[3].show}:flex`]">
                                                    <slot   name="col-4"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[3].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 5 -->
                                                <div    v-if="headers.length >= 5"
                                                        @click="selectRow(rowIndex, 4)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[4].show === 'sm' || !('show' in headers[4]) ? `flex` : `hidden ${headers[4].show}:flex`]">
                                                    <slot   name="col-5"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[4].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 6 -->
                                                <div    v-if="headers.length >= 6"
                                                        @click="selectRow(rowIndex, 5)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[5].show === 'sm' || !('show' in headers[5]) ? `flex` : `hidden ${headers[5].show}:flex`]">
                                                    <slot   name="col-6"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[5].key] }}</span>
                                                    </slot>
                                                </div>
                                            </slot>

                                        </div>
                                        </div>
                                    </context-menu>

                                    <div    v-else
                                            :class="tableColors[tableColorSet]['hoverBackgroundColor']"
                                            class="flex flex-row hover:bg-gray-100 overflow-y-visible">
                                        <div
                                                class="grow grid overflow-y-visible"
                                                @mousedown="startRowPress"
                                                @mouseup="endRowPress"
                                                :class="columnClasses + [rowSelectable ? ' cursor-pointer ' : ''] + [rowIndex === $data._selectedRow && this.allowHighlightedRows ? ' bg-blue-300 ' : '']">
                                            <slot   name="table-row"
                                                    :row="row"
                                                    :rowIndex="rowIndex">
                                                <!-- Column 1 -->
                                                <div    v-if="headers.length >= 1"
                                                        @click="selectRow(rowIndex, 0)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[0].show === 'sm' || !('show' in headers[0]) ? `flex` : `hidden ${headers[0].show}:flex`]">
                                                    <slot   name="col-1"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[0].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 2 -->
                                                <div    v-if="headers.length >= 2"
                                                        @click="selectRow(rowIndex, 1)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[1].show === 'sm' || !('show' in headers[1]) ? `flex` : `hidden ${headers[1].show}:flex`]">
                                                    <slot   name="col-2"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[1].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 3 -->
                                                <div    v-if="headers.length >= 3"
                                                        @click="selectRow(rowIndex, 2)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[2].show === 'sm' || !('show' in headers[2]) ? `flex` : `hidden ${headers[2].show}:flex`]">
                                                    <slot   name="col-3"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[2].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 4 -->
                                                <div    v-if="headers.length >= 4"
                                                        @click="selectRow(rowIndex, 3)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[3].show === 'sm' || !('show' in headers[3]) ? `flex` : `hidden ${headers[3].show}:flex`]">
                                                    <slot   name="col-4"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[3].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 5 -->
                                                <div    v-if="headers.length >= 5"
                                                        @click="selectRow(rowIndex, 4)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[4].show === 'sm' || !('show' in headers[4]) ? `flex` : `hidden ${headers[4].show}:flex`]">
                                                    <slot   name="col-5"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[4].key] }}</span>
                                                    </slot>
                                                </div>

                                                <!-- Column 6 -->
                                                <div    v-if="headers.length >= 6"
                                                        @click="selectRow(rowIndex, 5)"
                                                        class="items-center px-4 py-4 sm:px-6 overflow-y-visible overflow-x-hidden"
                                                        :class="[headers[5].show === 'sm' || !('show' in headers[5]) ? `flex` : `hidden ${headers[5].show}:flex`]">
                                                    <slot   name="col-6"
                                                            :row="row"
                                                            :rowIndex="rowIndex">
                                                        <span>{{ row[headers[5].key] }}</span>
                                                    </slot>
                                                </div>
                                            </slot>

                                        </div>
                                    </div>
                                </li>
                            </slot>
                        </ul>
                    </div>
                    
                    <!-- Below table area -->
                    <div>
                        <slot   name="below_table">
                            
                        </slot>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import JsonExcel from '@/components/JsonExcel'
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue'

import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import GreenButton from "@/components/elements/green-button";
import axios from "axios";
import ButtonGreenPrimary from "./buttons/ButtonGreenPrimary";



export default {
    name: "TailwindTable",
    mixins: [iconNamesMixin],
    emits: ['update:selectedRow', 'rowSelected', 'update:sort-by'],
    components: {ButtonGreenPrimary, GreenButton, 'download-excel' : JsonExcel, ContextMenu},
    props: {
        headers: Array,
        data: Array,
        rowsWithErrors: {
            type: Array,
            default: () => {
                return []
            }
        },
        sortable: {
            type: Boolean,
            default: false,
        },
        sortBy: {
            type: String,
            default: '',
        },
        sortDesc: {
            type: Boolean,
            default: false,
        },
        exportable: {
            type: Boolean,
            default: true,
        },
        exportFetchRoute: {
            type: String,
            default: null,
        },
        exportFetchParameters: {
            type: Object,
            default: () => {
                return {}
            },
        },
        exportCsvHeader: {
            type: Object,
            default: () => {
                return null
            }
        },
        rowSelectable: {
            type: Boolean,
            default: true,
        },
        noDataMessage: {
            type: String,
            default: 'No Data Found',
        },
        selectedRow: {
            type: [Number, null],
            default: null,
        },
        allowHighlightedRows: {
            type: Boolean,
            default: false,
        },
        useGroupTableStyling: {
            type: Boolean,
            default: false,
        },
        contextMenuEnabled: {
            type: Boolean,
            default: false
        },
        contextMenuResource: {
            type: String,
            default: null
        },
        contextMenuResourceIdKey: {
            type: String,
            default: 'id'
        }
    },
    data() {
        return {
            _selectedRow: null,

            // True when the mouse press that is about to fire a click ended up highlighting text
            textSelectedDuringPress: false,

            tableColors: {
                standardTable: {
                    // Table Colors
                    headerBackgroundColor: 'bg-white',
                    hoverBackgroundColor: 'hover:bg-gray-50',
                    rowPrimaryBackgroundColor: 'bg-gray-50',
                    rowSecondaryBackgroundColor: 'bg-gray-100',
                    rowSelectedBackgroundColor: 'bg-blue-500',

                    // Group Colors
                    groupRowBackgroundColor: 'bg-white',

                    // Errors
                    rowErrorColor: 'bg-red-200',
                    rowWarningColor: 'bg-yellow-200',
                },
                groupTable: {
                    // Table Colors
                    headerBackgroundColor: 'bg-gray-50',
                    hoverBackgroundColor: 'hover:bg-gray-100',
                    rowPrimaryBackgroundColor: 'bg-white',
                    rowSecondaryBackgroundColor: 'bg-white',
                    rowSelectedBackgroundColor: 'bg-blue-500',

                    // Group Colors
                    groupRowBackgroundColor: 'bg-gray-200',

                    // Errors
                    rowErrorColor: 'bg-red-200',
                    rowWarningColor: 'bg-yellow-200',
                },
            },

            // Table Color Set
            tableColorSet: 'standardTable',
        }
    },
    created() {
        if (this.useGroupTableStyling) {
            this.tableColorSet = 'groupTable'
        }
    },
    mounted() {
        
    },
    methods: {
        updateSort(sortBy) {
            this.$emit('update:sort-by', sortBy)
        },
        // Dragging across cells to highlight text fires a click on the cell too, which would
        // select the row (and pop open whatever panel the parent hangs off rowSelected) while
        // the browser throws the highlight away. Remember whether the press that produced this
        // click left text selected so selectRow can ignore it and let the user copy.
        startRowPress() {
            this.textSelectedDuringPress = false
        },
        endRowPress() {
            let selection = window.getSelection()

            this.textSelectedDuringPress = ! _.isNil(selection) && ! selection.isCollapsed && selection.toString().trim() !== ''
        },
        selectRow(index, colIndex) {
            if (! this.rowSelectable) {
                return
            }
            if (this.textSelectedDuringPress) {
                return
            }
            if (Object.keys(this.headers[colIndex]).indexOf('canClick') && this.headers[colIndex].canClick === false) {
                return
            }


            this.$data._selectedRow = index
            this.$emit('rowSelected', index)
        },
        // This is cool, makes sure the request is inline, only issue is it could hold up the page for long requests
        // TODO: Make it so if the export has more than some number N alarms, we should instead flash a notification
        //      that it is a large request & we will email them the csv when completed.
        async exportData() {
            this.exporting = true
            let params = JSON.parse(JSON.stringify(this.exportFetchParameters))
            params.page = 1
            params.itemsPerPage = params.pageInfo.total.toString()

            let newData = []
            const response = await axios.get(this.exportFetchRoute, {
                params: params
            })

            newData = response.data.data !== undefined ? response.data.data : []
            this.exporting = false

            return newData
        },
        getRowColor(rowIndex) {
            // return (rowIndex % 2 === 1 && rowIndex !== this.$data._selectedRow) ? this.tableColors[tableColorSet]['rowSecondaryBackgroundColor'] : '', (rowIndex === this.$data._selectedRow && this.allowHighlightedRows) ? this.tableColors[this.tableColorSet]['rowSelectedBackgroundColor'] : ''
            // If Error rows are set, see if this row is an error row, if so, return the error color
            if (this.rowsWithErrors.length > 0) {
                if (this.rowsWithErrors.includes(rowIndex)) {
                    return this.tableColors[this.tableColorSet]['rowErrorColor']
                }
            }

            // When we highlight selected rows, it should highlight a row if it is selected
            if (this.allowHighlightedRows) {
                if (rowIndex === this.$data._selectedRow) {
                    return this.tableColors[this.tableColorSet]['rowSelectedBackgroundColor']
                }
            }

            // Otherwise fallback to the standard row alternating colors
            return (rowIndex % 2 === 1) ? this.tableColors[this.tableColorSet]['rowSecondaryBackgroundColor'] : ''
        }
    },
    computed: {
        exportCsvFields() {
            if (!_.isNil(this.exportCsvHeader)) {
                return this.exportCsvHeader
            }

            let csvHeaders = {}
            let valid = true
            this.headers.forEach(header => {
                if (!('key' in header)) {
                    valid = false
                    return
                }
                csvHeaders[header.name] = header.key
            })
            return valid ? csvHeaders : null
        },
        columnClasses() {
            if (_.isNil(this.headers)) {
                return ''
            }
            let sizes = {
                sm: 0,
                md: 0,
                lg: 0,
                xl: 0,
            }
            this.headers.forEach(item => {
                if ('show' in item) {
                    if (item['show'] in sizes) {
                        sizes[item['show']]++
                    }
                    else {
                        sizes.sm++
                    }
                }
                else {
                    sizes.sm++
                }
            })
            sizes.md = sizes.md + sizes.sm
            sizes.lg = sizes.lg + sizes.md
            sizes.xl = sizes.xl + sizes.lg

            return ` grid-cols-${sizes.sm} md:grid-cols-${sizes.md} lg:grid-cols-${sizes.lg} xl:grid-cols-${sizes.xl} `
        },
    },
    watch: {
        selectedRow(val, old) {
            if (val !== old) {
                this.$data._selectedRow = val
            }
        },
        _selectedRow(val, old) {
            if (val !== old) {
                this.$emit('update:selectedRow', val)
            }
        },
    },
}
</script>

<style scoped>
/* Ensure the context menu wrapper doesn't break the table layout */
:deep(.table-row-context-wrapper) {
    display: block;
}
</style>